import { useQuery } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import { QueryKey } from '@shared/config';

export const useGetVacancyStatuses = () => {
  return useQuery({
    queryKey: [QueryKey.GET_VACANCY_STATUSES],
    queryFn: () => vacancyApi.getVacancyStatuses(),
  });
};
